import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

const RecircByTag = ({ recircRef }) => {
  const [hide, setHide] = useState(null);
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    const mql = window.matchMedia('(max-width: 639px)');
    mql.addEventListener('change', () => setHide(mql.matches));
    setHide(window.innerWidth <= 639);

    const apikey = 'fastcompany.com';
    const secret = 'Ldqx1NBhAHGqsuzIEaGqfzdmrnojHLYPoCdw4ISeZxU';
    const url = `https://api.parsely.com/v2/referrers/social/posts?apikey=${apikey}&secret=${secret}&domain=twitter.com&period_start=14d&limit=10`;

    const sections = ['co-design', 'technology', 'work-life', 'news', 'impact'];

    axios(url).then(res => {
      const feed = res.data.data
        .filter(article => sections.includes(article.section))
        .slice(0, 3);
      window.recircArticles = feed; // Make these easily available to the finite scroll components.
      setArticles(feed);
    });
  }, []);

  // Articles for this module are handled by a data call in src/views/containers/pages/post_page/post_page.js
  if (hide || !articles) return false;

  return (
    <aside className="article-recirc-by-tag" ref={recircRef}>
      <div className="header">
        <div className="top-arrow">
          <img
            src="https://images.fastcompany.net/image/upload/v1595605760/fcweb/Path_33_zlkv0h.svg"
            alt=""
          />
        </div>

        <div className="package-name">More Like This</div>
      </div>

      <div className="articles">
        {articles.map(article => (
          <div className="article" key={article.title}>
            <a
              href={`${article.link}&icid=dan902:754:0:editRecirc`}
              dangerouslySetInnerHTML={{ __html: article.title }}
            />
          </div>
        ))}
      </div>
    </aside>
  );
};

RecircByTag.propTypes = {
  recircRef: PropTypes.node
};

RecircByTag.defaultProps = {
  recircRef: null
};

export default RecircByTag;
